import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=267e61ec&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=267e61ec&prod&lang=scss"
import style1 from "./Company.vue?vue&type=style&index=1&id=267e61ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e61ec",
  null
  
)

export default component.exports